import { useState, useEffect } from "react";

export default function useIsWideImage(url, threshold = 1.15) {
    const [isWide, setIsWide] = useState(false);

    useEffect(() => {
        if (!url) return;

        const img = new Image();
        img.onload = () => {
            const { naturalWidth: w, naturalHeight: h } = img;
            if (w && h) setIsWide(w / h >= threshold);
        };
        img.src = url;

        return () => {
            img.onload = null;
        };
    }, [url, threshold]);

    return isWide;
}
